import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ForgotPassword.module.scss';
import {history} from 'components/App/components/UnauthenticatedApp';

import ButtonTransparentWhite from 'components/UI/ButtonTast/ButtonTransparentWhite/ButtonTransparentWhite';
import ButtontransparentYellow from 'components/UI/ButtonTast/ButtonTransparentYellow/ButtonTransparentYellow';
import ButtonYellow from 'components/UI/ButtonTast/ButtonYellow/ButtonYellow';
import ButtonText from 'components/UI/ButtonTast/ButtonText/ButtonText';

import passwordRequest from 'actions/password/forgot';

const mapDispatchToProps = {
    passwordRequest
};

class ForgotPassword extends Component {


    constructor() {
        super();

        this.state = {
            email: ''
        }

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.requestNewPassword = this.requestNewPassword.bind(this);

    }

    handleEmailChange(event) {
        this.setState({email: event.target.value});
    }

    requestNewPassword() {
        this.props.passwordRequest(this.state);
    }
    
    render() {
        return (
            <div styleName="container">
                <div styleName="art">
                    
                </div>
                <div styleName="login">
                    <div styleName="form" style={{top:'45%'}}>
                        <h2>WACHTWOORD VERGETEN</h2>
                        <form>
                          <label>Email-adres</label><input value={this.state.email} onChange={this.handleEmailChange} type="text" name="fname"/>
                            
                        </form>
                            <ButtonYellow text='STUUR RESET LINK' handleClick={this.requestNewPassword} />
                            <ButtontransparentYellow text='INLOGGEN' link='/login'/>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./resources/assets/screens/ForgotPassword/ForgotPassword.jsx